export const SHEET_TYPE = {
  COVER: 0,
  FRONT_COVER: 1,
  BACK_COVER: 2,
  NORMAL: 3
};

export const HALF_SHEET = [SHEET_TYPE.FRONT_COVER, SHEET_TYPE.BACK_COVER];

export const HALF_LEFT = [SHEET_TYPE.BACK_COVER];
